import i18n from "i18next";


export const IVA = 0.22
export const AZURE_MAPS_KEY =
    "CGQzkW7cAuKVOhYCUnWrgzTVyQYPwcN7lpkJFdhJ2Fg3GLgtMRHtJQQJ99CGAC8vTInI8D54AAAgAZMPCyaL";
export const urlCatasto= "http://catastoenergetico.org"
export const urlDOSpaces = "https://energo.fra1.digitaloceanspaces.com/"
export const urlCatastoHome = "http://catastoenergetico.org/topmenu/MyHome.aspx"
export const urlAddEdificio = urlCatasto+"/edit/gestioneedificio.aspx?Skeda=NUOVA&IDUNI=mve0ht2usgo1exm3sjdmwkau8997&MDId=4101"
export const refBase64IdCommunity = "community-5MiaiwdAPUHOtzTqcE5S"
export const refBase64IdPlant = "plant-we8fs88fd8djs"

export const THEMES = {
  LIGHT: 'LIGHT',
};
export const DEFAULT_WEBSITE_ONBOARDING = "http://catastoenergetico.org"
export const LINK_PRIVACY = "https://www.iubenda.com/privacy-policy/87466855"
export const LINK_COOKIE_POLICY = "https://www.iubenda.com/privacy-policy/87466855/cookie-policy"

export const PROPERTY_BUILDING_SEARCH =   ['property.name', 'cap','address.addressComplete','property.fiscalCode'];
export const PROFESSIONAL_COLOR: string = '#3D8AF7';
export const ESTIMATED_COLOR: string = '#FFA834';
export const OFFICIAL_COLOR: string = '#72BB53';


export const sectionsAppLogged = [
  {
    title: "",
    items: [
      {
        title: i18n.t("i_tuoi_edifici"),
        path: "/building",
      },
      {
        title: i18n.t("comunita_energetiche"),
        path: "/mycommunities",
      },
      {
        title: i18n.t("gestione_sottoscrizioni"),
        path: "/subscriptions",
      }
    ],
  },
];


export const sectionsAppUnLogged = [
  {
    title: "",
    items: [

    ]
  }
];
export const sectionsAppLoggedManutentore = [
  {
    title: "",
    items: [
      {
        title: i18n.t("i_tuoi_edifici"),
        path: "/building",
      },
      {
        title: i18n.t("comunita_energetiche"),
        path: "/mycommunities",
      },
      {
        title: i18n.t("gestione_sottoscrizioni"),
        path: "/subscriptions",
      },
    ],
  },
];


export const sectionsAppLoggedBackOffice = [
  {
    title: "",
    items: [
      {
        title: i18n.t("condomini"),
        path: '/building',
      },
      {
        title: i18n.t("utenti"),
        path: '/bo/users',
      },
      {
        title: i18n.t("gestione_comunita"),
        path: '/bo/communities',
      },
      {
        title: i18n.t("pagamenti"),
        path: '/bo/buildings',
      },
    ]
  }
];

/**CODICE COUPON **/
export const codiceDUFERCO = "00100"
export const VAT_RATE_22 = 0.22;

export const productIDDiagnosi = 1;
export const DIAGNOSI_BASE_PRICE_EUR = 500;

